module.exports = __webpack_public_path__ + "static/img/qr_code.4d36476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liquor/qr_code.png
// module id = +ss4
// module chunks = 21